







































import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import DialogEventsMixin from '../../components/dialog/DialogEventsMixin';
import HomeApi from '@/api/HomeApi';
import {HomeNoticeDetailRetrieveData, HomeNoticeDetailRetrieveResponse} from '@/model/CommonModel';
import NoticeViewer from '@/views/home/NoticeViewer.vue';
import IconButton from '@/components/button/IconButton.vue';
import ApiUtils from '@/utils/ApiUtils';
import DefaultComponentMixin from '@/views/DefaultComponentMixin';
import BooleanCheckboxInput from '@/components/input/BooleanCheckboxInput.vue';

@Component({
  components: {
    CommonPromptDialog, CommonButton, NoticeViewer, IconButton, BooleanCheckboxInput
  },
  mixins: [
    DialogEventsMixin, DefaultComponentMixin
  ],
  filters: {
    hyphenToPoint: (value: any) => {
      if (!value) {
        return '';
      }
      return value.replace(/-/gi, '.');
    }
  }
})
export default class NoticeDetailDialog extends Mixins(DialogEventsMixin, DefaultComponentMixin) {
  private visible: boolean = false;
  @Prop({default: false}) private editable: boolean;
  @Prop({default: -1}) private noticeKey: number;
  @Prop({default: false}) private popup: boolean;
  private value: HomeNoticeDetailRetrieveData = {
    alarmEmail: '',
    content: '',
    delFlag: '',
    effectDate: '',
    expireDate: '',
    country: null,
    fileList: [{fileKey: -1, fileName: ''}],
    new: false,
    noticeAll: '',
    noticeKey: 0,
    regTime: '',
    title: '',
    userName: '',
  };
  private recipientsLoading: boolean = false;
  private isCheckedDoNotRemindAgain: boolean = false;
  private isCheckedDoNotRemindTomorrow: boolean = false;

  get isVisible() {
    return this.visible;
  }

  get isEditable() {
    return this.getValue.noticeAll === 'Y' ? this.isAdmin : this.editable;
  }

  get sponsorKey() {
    return this.isAdmin ? 1 : parseInt(this.$route.params.sponsorKey, 10);
  }

  get getCookieKey() {
    return `NOTICE_POPUP_${this.getValue.country}_${this.sponsorKey}`;
  }

  get getValue() {
    return this.value;
  }

  get isPopup() {
    return this.popup;
  }

  public mounted() {
    if (this.popup) {
      this.watchNoticeKey();
    }
  }

  @Watch('noticeKey')
  public watchNoticeKey() {
    if (!this.noticeKey) {
      return;
    }
    this.recipientsLoading = true;
    HomeApi.retrieveNoticeDetail(this.sponsorKey, this.noticeKey)
        .then((res: HomeNoticeDetailRetrieveResponse) => {
          if (!res.success) {
            return Promise.reject(res.errMsg);
          }
          this.value = res.data;
          this.value.country = this.value.country ?? 'ALL';
          this.recipientsLoading = false;
          this.visible = true;
        })
        .catch((errMsg) => this.afterRequestFail(errMsg));
  }

  public onFileClick($event: any, fileKey: number) {
    $event.stopPropagation();
    HomeApi.downloadFileOnNoticeDetailDialog(this.sponsorKey, fileKey)
        .then(ApiUtils.fileDownloadHandler, ApiUtils.rejectedHandler);
  }

  public onEdit() {
    const name = this.isAdmin ? 'AdminNoticeDetail' : 'NoticeDetail';
    this.$router.push({
      name,
      params: {
        noticeKey: this.noticeKey ? this.noticeKey.toString() : '',
        ...ApiUtils.extractRequiredParams(this.$route.params)
      }
    });
  }

  public onCheck(isCheckedDoNotRemindTomorrow: boolean) {
    if (isCheckedDoNotRemindTomorrow) {
      this.isCheckedDoNotRemindAgain = false;
    } else {
      this.isCheckedDoNotRemindTomorrow = false;
    }
  }

  public getCookieExpireDate() {
    if (this.isCheckedDoNotRemindAgain && !this.getValue.expireDate) {
      return Infinity;
    }
    const expireDate = this.isCheckedDoNotRemindAgain ? new Date(this.getValue.expireDate) : new Date();
    expireDate.setHours(24, 0, 0, 0); // 다음날 00시
    return expireDate;
  }

  public onConfirm() {
    if (this.isPopup && (this.isCheckedDoNotRemindAgain || this.isCheckedDoNotRemindTomorrow)) {
      this.$cookies.set(this.getCookieKey, this.noticeKey, this.getCookieExpireDate());
    }

    this.visible = false;
    this.$emit('confirm');
  }

  public onClose() {
    this.$emit('close');
  }
}
